import React, {useState, useEffect} from "react";
import moment from "moment";
import { Link, useParams, useNavigate } from "react-router-dom";

import {CallerDataAPI} from "./../../API/Sales/DashboardAPI";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";
import Paginate from "../../utils/Pagination";


const CallersList = () =>{

    const {teamid} = useParams();

    const [callerdata, setCallerData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const navigate = useNavigate();

    const perpagedata = 20;

    const current = moment();

    useEffect(() =>{

        console.log("Step 1" + teamid);

        CallerDataAPI(setCallerData, teamid, setLoading, currentPage, perpagedata, setPageCount);
        
    }, [currentPage]);

    const handleReloadCallerData = () =>{
        CallerDataAPI(setCallerData, teamid, setLoading, currentPage, perpagedata, setPageCount);
    }

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const sendBackPage = () =>{
		navigate(-1)
	}

    return(
    <Layout>
        <div className="content">
            <div class="welcome-wrap mb-4">
				<div class=" d-flex align-items-center justify-content-between flex-wrap crm-welcome-bar">
					<div class="d-flex align-items-center flex-wrap mb-1 crm-top-actions">
                        <button type="button" className="btn btn-success crm-refresh-btn me-2" onClick={sendBackPage}>
                            <i className="ti ti-arrow-narrow-left me-1"></i>Back
                        </button>

						<button type="button" class="btn btn-primary crm-refresh-btn" onClick={handleReloadCallerData}>
                            <i className={`ti ti-refresh me-1`}></i>Refresh
                        </button>
					</div>
				</div>
			</div>
            <div className="row crm-report-row">
                <div className="col-md-12">
                    <div className="card w-100 crm-caller-report-list">
                        <div className="card-header border-0 pb-0">
                            <h4 className="mb-2">
                                <i className="ti ti-grip-vertical me-1"></i>Caller Leads Report
                            </h4>
                        </div>
                        <div className="card-body">
                            {loading ?
                                <ContentLoader />
                            :

                            <div className="table-responsive crm-report-table-wrap">
                                <table class="table table-nowrap mb-0">
                                    <thead class="thead-light">
                                        <tr>
                                            <th>Caller Name</th>
                                            <th>Fresh</th>
                                            <th>Warm</th>
                                            <th>Cold</th>
                                            <th>Dead</th>
                                            <th>Followup Today</th>
                                            <th>Followup Pending</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {
                                    callerdata && callerdata.length > 0  ?
                                        callerdata.map(caller =>
                                            (
                                                <tr key={caller.id}>
                                                    <td>
                                                        <div class="avatar avatar-sm border flex-shrink-0 me-2">
                                                            <span class="initials">{(caller.name).slice(0,2)}</span>
                                                        </div>
                                                        <Link to={`/team/lead-profile/${caller.id}`} class="">
                                                        {caller.name}
                                                        </Link>
                                                    </td>
                                                    <td>{caller.freshcount}</td>
                                                    <td>{caller.warmcount}</td>
                                                    <td>{caller.coldcount}</td>
                                                    <td>{caller.deadcount}</td>
                                                    <td>{caller.todayfollowup}</td>
                                                    <td>{caller.totalpendingfollowup}</td>
                                                </tr>

                                            )
                                        )

                                    :

                                        <tr>
                                            <td colSpan="7">
                                                <center>No records found</center>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                            </div>
                            }
                        </div>
                    </div>
                </div>					
            </div>
        </div>
    </Layout>
    )
}

export default CallersList;
